'use strict';
import * as $j_app$002eapi$002eapp$005fupdates$0024package$0024$002dIn$002dMaintenance$002dMessage$0024 from "./app.api.app_updates$package$-In-Maintenance-Message$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_InMaintenanceData$$anon$4() {
}
export { $c_Lapp_api_InMaintenanceData$$anon$4 as $c_Lapp_api_InMaintenanceData$$anon$4 };
$c_Lapp_api_InMaintenanceData$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_InMaintenanceData$$anon$4.prototype.constructor = $c_Lapp_api_InMaintenanceData$$anon$4;
/** @constructor */
function $h_Lapp_api_InMaintenanceData$$anon$4() {
}
export { $h_Lapp_api_InMaintenanceData$$anon$4 as $h_Lapp_api_InMaintenanceData$$anon$4 };
$h_Lapp_api_InMaintenanceData$$anon$4.prototype = $c_Lapp_api_InMaintenanceData$$anon$4.prototype;
$c_Lapp_api_InMaintenanceData$$anon$4.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_InMaintenanceData$$anon$4.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy1 = $j_app$002eapi$002eapp$005fupdates$0024package$0024$002dIn$002dMaintenance$002dMessage$0024.$m_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$();
  return $x_2.schemaForOption__Lsttp_tapir_Schema__Lsttp_tapir_Schema($x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString));
});
$c_Lapp_api_InMaintenanceData$$anon$4.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_InMaintenanceData$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_InMaintenanceData$$anon$4, "app.api.InMaintenanceData$$anon$4", ({
  Lapp_api_InMaintenanceData$$anon$4: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_InMaintenanceData$$anon$4 as $d_Lapp_api_InMaintenanceData$$anon$4 };
//# sourceMappingURL=app.api.-In-Maintenance-Data$$anon$4.js.map
